import { Injectable } from "@nestjs/common";
import { LocationAuditDto } from "./dto/location-audit.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { LocationAuditAdapter } from "./location-audit.adapter";
import { InjectRepository } from "@nestjs/typeorm";
import { LocationAudit } from "./entity/location-audit.entity";
import { Repository, getManager } from "typeorm";
import appSettings from "apps/services/config";
import { LocationById } from "../locations/dto/locaion-get-by-id.dto";

@Injectable()
export class LocationAuditService {
    constructor(
        private adapter:LocationAuditAdapter,
        @InjectRepository(LocationAudit)
        private repo: Repository<LocationAudit>,
    ){}

    async createLocationAudit(req:LocationAuditDto) :Promise<CommonResponse> {
        const locationEntity = this.adapter.convertDtoToLocationAuditEntity(req);
        const locationAuditSave = await this.repo.save(locationEntity)
        return new CommonResponse(true,1,'Created Successfully',locationAuditSave)
    }

    async updateLocationAudit(req:LocationAuditDto):Promise<CommonResponse> {
        const locationEntity = this.adapter.convertDtoToLocationAuditEntity(req);
        const locationAuditSave = await this.repo.update({locationId:req.locationId},{working:req.working,Notworking:req.Notworking,reason:req.reason,status:req.status})
        return new CommonResponse(true,1,'Updated Successfully',locationAuditSave)
    }

    async getLocationAuditDetails():Promise<CommonResponse>{
        const manager = getManager();
        let getEntities = `SELECT loau.audit_id,loau.location_id,loau.audit_type,loau.audit_date,loau.start_date,loau.completed_date,loau.audit_provider,loau.audit_name,
        loau.audit_owner,loau.phone_number,loau.working,loau.not_working,loau.status,loau.remarks,loau.reason,lo.location_name,loau.assets_count
        FROM `+appSettings.assets_db+`.location_audit loau
        LEFT JOIN `+appSettings.assets_db+`.location lo ON lo.location_id = loau.location_id`
        const data = await manager.query(getEntities);
        return new CommonResponse(true,1,'Data retrieved successfully',data)
    }

    async getAssetsByLocation(req:LocationById):Promise<CommonResponse>{
        const manager = getManager()
        let getEntities = `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.asset_category,aas.asset_mode,aas.asset_type,lo.location_name,aas.status,it.item_name,isc.item_sub_category
        FROM `+appSettings.assets_db+`.assets aas
        LEFT JOIN `+appSettings.assets_db+`.asset_location_mapping lom ON lom.asset_id = aas.asset_id
        LEFT JOIN `+appSettings.assets_db+`.location lo ON lo.location_id = lom.location_id
        LEFT JOIN `+appSettings.masters_db+`.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE lo.location_id = ${req.locationId}`
        const data = await manager.query(getEntities);
        return new CommonResponse(true,1,'Data retrieved successfully',data)
    }
 }